import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { utagLinkPDP } from 'features/tealium';

import { applyFilter } from '../reducers';
import './ProductReviewRatingGraph.scss';

const ProductReviewRatingGraph = ({ reviewsSummary }) => {

	const dispatch = useDispatch();
	const { reviewFilters } = useSelector((state) => state.productReviews);
	const ratingBreakdown = [
		{
			rating: 5,
			percent: reviewsSummary.fiveStarRatingPercentage
		},
		{
			rating: 4,
			percent: reviewsSummary.fourStarRatingPercentage
		},
		{
			rating: 3,
			percent: reviewsSummary.threeStarRatingPercentage
		},
		{
			rating: 2,
			percent: reviewsSummary.twoStarRatingPercentage
		},
		{
			rating: 1,
			percent: reviewsSummary.oneStarRatingPercentage
		}
	];

	const handleRatingClick = (rating) => {

		dispatch(applyFilter({ value: rating, label: `${rating} Star` }));
		utagLinkPDP('TurnTo')({
			eventAction: 'Click-Ratings-Filter',
			eventLabel: rating
		});

	};
	return (
		<section className="ProductReviewRatingGraph">
			<div className="ProductReviewRatingGraph__ratingsCount">
				{reviewsSummary.ratings}
				{' '}
				<span>
					{`Rating${reviewsSummary.ratings > 1 ? 's' : ''}`}
				</span>
			</div>
			<div className="ProductReviewRatingGraph__chart">
				{ratingBreakdown.map(({ rating, percent }) => {

					// check if filter is already applied and disable row
					const isActiveFilter = Boolean(reviewFilters.find((f) => f.value === rating));
					const isDisabled = percent === 0 || isActiveFilter;
					return (
						<button
							key={`graph-${rating}`}
							type="button"
							className="ProductReviewRatingGraph__chartRow"
							disabled={isDisabled}
							onClick={() => handleRatingClick(rating)}
						>
							<span className="ProductReviewRatingGraph__chartRating">
								<span className="lpIcon-star-selected ProductReviewRatingGraph__chartRatingStar" />
								{rating}
							</span>
							<span className="ProductReviewRatingGraph__bar">
								<span
									className="ProductReviewRatingGraph__barInner"
									style={{
										width: `${percent}%`
									}}
								/>
							</span>
							<span className="ProductReviewRatingGraph__chartRatingPercent">
								{`${percent}%`}
							</span>
						</button>
					);

				})}
			</div>
		</section>
	);

};

ProductReviewRatingGraph.propTypes = {
	reviewsSummary: PropTypes.shape({
		ratings: PropTypes.number.isRequired,
		fiveStarRatingPercentage: PropTypes.number.isRequired,
		fourStarRatingPercentage: PropTypes.number.isRequired,
		threeStarRatingPercentage: PropTypes.number.isRequired,
		twoStarRatingPercentage: PropTypes.number.isRequired,
		oneStarRatingPercentage: PropTypes.number.isRequired
	})
};

export default ProductReviewRatingGraph;
